import { render, staticRenderFns } from "./VoiceMemo.vue?vue&type=template&id=61dd6245&scoped=true"
import script from "./VoiceMemo.vue?vue&type=script&lang=js"
export * from "./VoiceMemo.vue?vue&type=script&lang=js"
import style0 from "./VoiceMemo.vue?vue&type=style&index=0&id=61dd6245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd6245",
  null
  
)

export default component.exports